import React, { useState, useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Button } from '@mic3/platform-ui';
import ModalDialog from 'app/components/organisms/ModalDialog/ModalDialog';
import EntityTypesTypeahead from 'app/components/organisms/Form/Typeahead/EntityTypesTypeahead';
import RelationDefinitionTypeahead from 'app/components/organisms/Form/Typeahead/RelationDefinitionTypeahead';
import TreeCheckboxes from 'app/components/molecules/TreeCheckboxes/TreeCheckboxes';

const RelationAttributeModal = ({ 
    updateAttributesOrder, open, onClose, onApply, relatedEntity, entityType, normalizeDefintionsToCheckboxes,
    relatedEntityDefinition, relationDefinitionTreeValue, value: attributesListValue
}) => {
    const [localRelatedEntity, setLocalRelatedEntity] = useState(relatedEntity);
    const [localRelationDefinition, setLocalRelationDefinition] = useState(relatedEntityDefinition);
    const [localTreeValue, setLocalTreeValue] = useState(relationDefinitionTreeValue);
    const [updatedAttributes, setUpdatedAttributes] = useState(attributesListValue);

    useEffect(() => {
        setLocalTreeValue(relationDefinitionTreeValue);
    }, [relationDefinitionTreeValue]);
    useEffect(() => {
        setUpdatedAttributes(attributesListValue);
    }, [attributesListValue]);
    useEffect(() => {
        setLocalRelatedEntity(relatedEntity);
    }, [relatedEntity]);

    const handleApply = useCallback(() => {
        onApply(localTreeValue, updatedAttributes, localRelatedEntity,  localRelationDefinition)
        onClose();
    }, [localTreeValue, onApply, onClose, updatedAttributes, localRelatedEntity, localRelationDefinition]);
    
    const onChangeTree = useCallback(({ target: { value } }, nodes) => {
        let attributesList = updateAttributesOrder(updatedAttributes, nodes);
        attributesList = attributesList.map((val) => ({
            value: val.value,
            label: val.label,
            order: val.order,
            fieldType: val.fieldType,
        }));
        setLocalTreeValue(value);
        setUpdatedAttributes(attributesList);
    }, [updatedAttributes, updateAttributesOrder]);

    return (
        <ModalDialog title="Add Relationship Attributes" open={open} onClose={onClose} actions={<Button onClick={handleApply}>Apply</Button>}>
            <EntityTypesTypeahead
                name="relatedEntity"
                label="Related Entity type"
                fromType={entityType}
                value={localRelatedEntity}
                onChange={(e) => {
                    setLocalRelatedEntity(e.target.value);
                    setLocalRelationDefinition(null);
                    setLocalTreeValue(localTreeValue.filter((v) => !v.value.includes('relations') && !v.value === 'entity'));
                    setUpdatedAttributes(updatedAttributes.filter((attr) => !attr.value.includes('attributes')));
                }}
            />
            {localRelatedEntity && (
                <RelationDefinitionTypeahead
                    label="Relationship"
                    name="relatedEntityDefinition"
                    value={localRelationDefinition}
                    fromType={entityType}
                    toType={localRelatedEntity?.uri}
                    onChange={(e) => {
                        const nodes = [];
                        localTreeValue.forEach((p) => {
                            p.checked = false;
                            (p.children || []).forEach((ch) => {
                                ch.checked = false;
                                nodes.push(ch);
                            });
                        });
                        if (nodes.length) {
                            let attributesList = updateAttributesOrder(updatedAttributes, nodes);
                            attributesList = attributesList.map((val) => ({ value: val.value, label: val.label, order: val.order }));

                            setUpdatedAttributes(attributesList);
                        }
                        setLocalRelationDefinition(e.target.value);
                        const newLocalTree = normalizeDefintionsToCheckboxes([], null, updatedAttributes, e.target.value || null).map(def => {
                            if(def.value === 'entity') {
                                return { ...def, checked: false }
                            }
                            return def;
                        });
                        
                        setLocalTreeValue(newLocalTree);
                    }}
                    extraQueryFields={`
                    classes {
                        id
                        name
                        uri
                        formDefinition
                    }                        
                `}
                />
            )}
            <TreeCheckboxes name="classesDefintions" onChange={onChangeTree} value={localTreeValue} />
        </ModalDialog>
    );
};

RelationAttributeModal.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onApply: PropTypes.func.isRequired,
    relatedEntity: PropTypes.any,
    relatedEntityDefinition: PropTypes.any,
    relationDefinitionTreeValue: PropTypes.array.isRequired,
};

export default RelationAttributeModal;
